export const SUBSCRIPTION_KEY = "1665a0d65db64c2d8a148139a23e5f98";
export const SERVICE_REGION = "eastasia";
